/// <reference path="../../TypeLite.Net4.d.ts" />
import * as React from 'react'
import { ResourceProvider } from '../../resourceProvider';
import { TabType } from '../../components/wizard/wizardTabs/WizardTabPane';
import { SkodaTooltip } from '../skodaTooltip';

export interface IFilterItemProps {
    resourceTitle: string,
    value: string,
    isSelected: boolean,
    activateWizardTab: TabType,
    onclickFunction: (tab: TabType) => void,
    resourceTooltip?: string
}

export class FilterItem extends React.Component<IFilterItemProps, {}>
{
    constructor(props: IFilterItemProps) {
        super(props);
    }

    public render(): JSX.Element {
        const { resourceTitle, value, isSelected, activateWizardTab, onclickFunction, resourceTooltip } = this.props;
        let isLinked = onclickFunction != null ? true : false;
        let tooltip = resourceTooltip ? ResourceProvider.getText(resourceTooltip) : null;
        let showTooltip = tooltip && tooltip !== `#${resourceTooltip}`;

        return (
            <div className="filter-item" onClick={() => onclickFunction ? onclickFunction(activateWizardTab) : null}>
                <div className="filter-title-container">
                    <div className="filter-icon">
                        {this.renderFilterIcon(isSelected)}
                    </div>
                    <div className={isLinked ? "filter-title" : "filter-title-no-pointer"}>
                        <p>{ResourceProvider.getText(resourceTitle)}</p>
                    </div>
                    {showTooltip &&
                        <div className="filter-tooltip-icon">
                            {this.renderFilterTooltip(tooltip)}
                        </div>
                    }
                </div>
                {this.renderSelectedItem(value, isSelected)}
            </div>
        );
    }

    private renderSelectedItem(value: string, isSelected: boolean): JSX.Element {
        let isLinked = this.props.onclickFunction != null ? true : false;
        if (isSelected) {
            return (
                <div className={isLinked ? "filter-selected-item" : "filter-selected-item-no-pointer"}>
                    {value}
                </div>
            );
        } else {
            return (
                <div className={isLinked ? "filter-unselected-item" : "filter-unselected-item-no-pointer"}>
                    {ResourceProvider.getText('Filter.Item.Unselected')}
                </div>
            );
        }
    }

    private renderFilterIcon(isSelected: boolean): JSX.Element {
        if (isSelected) {
            return (
                <div className="filter-check-image"></div>
            );
        } else {
            return (
                <div className="filter-uncheck-image"></div>
            );
        }
    }

    private renderFilterTooltip(tooltip: string): JSX.Element {
        return (
            <SkodaTooltip id={"serviceVersionTooltip"} effect={"solid"} type={"dark"} message={tooltip}>
                <div className="filter-tooltip-image"></div>
            </SkodaTooltip>
        );
    }
}